import React from 'react'
import ReactDom from 'react-dom'
import { Provider } from 'react-redux'
import App from './components/App'
import { default as store } from './store'
import 'babel-polyfill'

// print the sightmap version to the console
console.info('Sightmap version: ', process.env.SIGHTMAP_VERSION)

ReactDom.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('main')
)
